import Header from '../Header';
import KPI from '../assets/KPIDashboard.svg';
import DMU from '../assets/DMUNew.svg';
import AssetTracking from '../assets/AssetTrackingNew.svg';
import UserManagment from '../assets/ManageUsers.svg';
import MaterialMovements from '../assets/MaterialMovementsNew.svg';
import Maintenance from '../assets/MaintenanceNew.svg';
import PreStartCheck from '../assets/PreStartChecks.svg';
import { UserContext } from '../service/userContext';
import { useContext, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { DepartmentNames, desiredOrder, links } from '../utils/constants';

export const icons = {
  500: [KPI],
  400: [DMU],
  200: [MaterialMovements],
  300: [Maintenance],
  600: [PreStartCheck],
  700: [UserManagment],
  800: [AssetTracking],
};

const LandingPage = () => {
  const navigate = useNavigate();
  const { userInfo, departments } = useContext(UserContext);
  const updatedDepartments = useMemo(() => {
    const sortedArray = departments.sort((a, b) => {
      const indexA = desiredOrder.indexOf(a.code);
      const indexB = desiredOrder.indexOf(b.code);
      if (indexA === -1) {
        return 1;
      }
      if (indexB === -1) {
        return -1;
      }
      return indexA - indexB;
    });
    return sortedArray;
  }, [departments]);

  const onDepartmentClick = (code) => {
    return navigate(links[code]);
  };
  return (
    <div className="h-auto mb-4 pt-3 px-3 landing-container">
      <Header showLogo />
      <div className="home-container">
        <div class="department-container">
          {updatedDepartments.map(({ name, code, is_restricted }, index) => {
            return (
              <div
                class={`department-item ${
                  is_restricted && !userInfo.departments.includes(code)
                    ? 'department-disabled'
                    : ''
                }`}
                key={index}
                onClick={() => {
                  if (
                    !(is_restricted && !userInfo.departments.includes(code))
                  ) {
                    onDepartmentClick(code);
                  }
                }}
              >
                <img
                  className="department-icon"
                  alt={name}
                  src={icons[code]}
                  key={code}
                />
                <p className="department-name">{DepartmentNames[code]}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
